import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { botApi } from '../bot/api'

/**
 * Landing decision for "/": users with at least one strategy go straight to
 * their first one; only users with none are sent to the create-strategy
 * popup. Errors fall back to the create route, the pre-existing behavior.
 */
export default function HomeRedirect() {
  const [target, setTarget] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    botApi
      .list()
      .then((bots) => {
        if (cancelled) return
        setTarget(bots?.length ? `/strategy/${bots[0].bid}` : '/strategy/create')
      })
      .catch((err) => {
        console.error('Error loading bots:', err)
        if (!cancelled) setTarget('/strategy/create')
      })

    return () => {
      cancelled = true
    }
  }, [])

  if (!target) return null

  return <Navigate to={target} replace />
}
